import CustomLogoFull from './logo/gdp-labs-logo-full-blue.png';
import React from 'react';

const LogoFull = () => {
  return (
    <img
      src={CustomLogoFull}
      alt="GDP Labs Logo Full"
      width={150}
      style={{ marginLeft: '12px' }}
    />
  );
};

export default LogoFull;
